import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./header";

import SEO from '../SEO/SEO';
import PageTitle from "../SEO/PageTitle";

const OnlyHeaderLayout = () => {
  return (
    <>
      <PageTitle />
      <SEO />
      <Header hideMenu = {true} />
      <Outlet />
    </>
  );
};

export default OnlyHeaderLayout;
